import React from 'react';

import { OKRTitle } from './OKRTitle';

interface Props {
  isSecondaryPanel?: boolean;
  isOpenAsParent?: boolean;
  savedOKRDetails?: any;
}

const PrimaryDetails = ({ isSecondaryPanel }: Props) => <OKRTitle isSecondaryPanel={isSecondaryPanel} />;

export { PrimaryDetails };
